<template>
  <div class="card printBoarder" id="printMe" ref="printMe">
    <div class="card-header pb-4">
      <div class="row mt-3 pt-3">
        <div class="col-md-6 col-sm-12">
          <div class="mb-4">
            <!-- Skeleton Loader for Image -->
            <div class="skeleton-image" style="width: 180px; height: 60px;"></div>
          </div>
          <div>
            <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Company -->
          </div>
          <div>
            <div class="skeleton-text skeleton-text-medium"></div> <!-- Skeleton for Address -->
          </div>
          <div>
            <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Email -->
          </div>
          <div>
            <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Phone -->
          </div>
        </div>
        <div class="col-md-6 col-sm-12 pull-left quote-header">
          <div class="row">
            <div class="col-md-12 col-sm-6">
              <h2 hidden id="docName" class="text-right mr-3"
                  style="font-family: 'Gill Sans',serif; font-weight: bolder">
                <div class="skeleton-text skeleton-text-large"></div> <!-- Skeleton for Name -->
              </h2>
              <h2 class="text-left mr-5 w101">
                <label readonly="readonly" type="text"
                       class="input text-right w99"
                       style="font-family: 'Gill Sans',serif; font-weight: bolder">
                  <div class="skeleton-text skeleton-text-medium"></div> <!-- Skeleton for Editable Name -->
                </label>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-0">
        <div class="col-md-4 col-sm-12 mt-3">
          <table class="tblInvoiceHeaderDetails table table-hover table-center mb-0 datatable borderless">
            <tbody>
            <tr class="text-right" style="border: 0;">
              <td class="text-left">
                <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Customer Name -->
              </td>
            </tr>
            <tr class="text-right" style="border: 0;">
              <td class="text-left">
                <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Customer Name -->
              </td>
            </tr>
            <tr class="text-right" style="border: 0;">
              <td class="text-left">
                <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Email or Phone -->
              </td>
            </tr>
            <tr class="text-right" style="border: 0;">
              <td class="text-left">
                <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Address -->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4 col-sm-12 mt-3">
          <table class="tblInvoiceHeaderDetails table table-hover table-center mb-0 datatable borderless">
            <tbody>
            <tr class="text-right" style="border: 0;">
              <td class="text-left">
                <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Shipping Email or Phone -->
              </td>
            </tr>
            <tr class="text-right" style="border: 0;">
              <td class="text-left">
                <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Shipping Email or Phone -->
              </td>
            </tr>
            <tr class="text-right" style="border: 0;">
              <td class="text-left">
                <div class="skeleton-text skeleton-text-small"></div> <!-- Skeleton for Shipping Address -->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4 col-sm-12 mt-3">
          <table class="tblInvoiceHeaderDetails table table-hover table-center mb-0 datatable borderless">
            <tbody>
            <tr class="text-right skeleton-text" style="border: 0;">
              <td class="text-left" style="font-weight: bold"></td>
              <td class="text-right">
                <div class="skeleton-text-small"></div> <!-- Skeleton for Invoice Number -->
              </td>
            </tr>
            <tr class="text-right skeleton-text" style="border: 0;">
              <td class="text-left"></td>
              <td class="text-right">
                <div class="skeleton-text-small"></div> <!-- Skeleton for Currency -->
              </td>
            </tr>
            <tr class="text-right skeleton-text" style="border: 0;">
              <td class="text-left"></td>
              <td class="text-right">
                <div class="skeleton-text-small"></div> <!-- Skeleton for Rate -->
              </td>
            </tr>
            <tr class="text-right skeleton-text" style="border: 0;">
              <td class="text-left"></td>
              <td class="text-right">
                <div class="skeleton-text-small"></div> <!-- Skeleton for Date -->
              </td>
            </tr>
            <tr class="text-right skeleton-text" style="border: 0;">
              <td class="text-left"></td>
              <td class="text-right">
                <div class="skeleton-text-small"></div> <!-- Skeleton for Due Date -->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card-body pt-2">
      <div class="table">
        <div>
          <table id="tblItems" class="table table-hover table-center mb-0 datatable borderless">
            <thead id="items-header">
            </thead>
            <tbody>
            <tr v-for="n in rows" :key="n">
              <td v-for="col in columns" :key="col">
                <div class="skeleton-text"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSkeleton from "./LoadingSkeleton";

export default {
  name: "DocumentSkeleton",
  components: {
    LoadingSkeleton,
  },
  props: {
    rows: {
      type: Number,
      default: 10,
    },
    columns: {
      type: Number,
      default: 6,
    },
  },
}
</script>

<style scoped>
.skeleton-text {
  height: 1.8rem;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-image {
  height: 1.8rem;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Ensure all tables are borderless */
table, th, td {
  border: none !important;
}

table {
  border-collapse: collapse;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/DocumentSkeleton.vue